<template>
    <google-analytics-inertia/>
    <HoneybadgerErrorTracking/>
    <div class="flex min-h-screen flex-col text-gray-900">
        <frontend-header v-if="!hideHeader"/>

        <slot name="page_header"/>

        <main class="flex-grow bg-white">
            <slot/>
        </main>

        <frontend-footer v-if="!hideFooter"/>
    </div>
</template>

<script>
import FrontendHeader from "@/Components/FrontendHeader";
import FrontendFooter from "@/Components/FrontendFooter";
import GoogleAnalyticsInertia from "@/Components/GoogleAnalyticsInertia.vue";
import HoneybadgerErrorTracking from "@/Components/HoneybadgerErrorTracking.vue";

export default {
    name: "Frontend",
    components: {
        HoneybadgerErrorTracking,
        GoogleAnalyticsInertia,
        FrontendFooter,
        FrontendHeader,
    },
    props: {
        hideHeader: {
            type: Boolean,
            default: false,
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped></style>
